// extracted by mini-css-extract-plugin
module.exports = {"root":"WizardHeader_root__3IuLs","title":"WizardHeader_title__P81cs","highlightedText":"WizardHeader_highlightedText__2YKyY"};